import React, { useState, useContext, useEffect } from "react";
import { v4 as uuid } from 'uuid';
import Dropdown from 'react-dropdown';
import { extraTranslations, interviewTranslations } from './RulesData';
import GlobalRulesContext from './RulesContext';
import './RulesTableStyles.scss';
import { useTranslation,Translation } from "react-i18next";
import { element } from "prop-types";
import { ListValLeft, MeasurementValLeft } from './types';

 const getLhsValues = (stepsInfo,translationJSON,mt,locale) => {
  let lhsVals = [];
  if (stepsInfo && stepsInfo.length > 0) {
    for (let step of stepsInfo) {
      if (step.type == "QuestionStep" ||
          step.type == "RatingStep" ||
          step.type == "MultiAnswerQuestionStep" ||
          step.type == "TextStep"){
        // Each and every element should have unique keys and labels for dropdown to work.
        const listValLeft: ListValLeft = {
          key: uuid(),
          step_id: step.id,
          type: step.type,
          value: step.step_rule_identifier, 
          label: step.label
        };
        // translations replaced to step loop if they exist.
        if(translationJSON.length > 0){
          for(var i=0; i<translationJSON.length; i++){
            if(translationJSON[i].id == listValLeft.step_id){
              listValLeft.label = translationJSON[i].translation;
            } 
          }
        }
        lhsVals.push(listValLeft);
      } 
      else if (step.type == "SensorStep") {
        if (step.measurements) {
          for (let measurement of step.measurements) {
            const measurementValLeft: MeasurementValLeft = {
              key: uuid(),
              step_id: step.id,
              type: step.type,
              //sensor_<stepRuleIdentifier>_<measurementId>
              value: "sensor_"+step.step_rule_identifier+"_"+ measurement.id, 
              label: measurement.description
            }
            if(mt.length > 0){
              for(var i=0; i<mt.length; i++){
                if(mt[i].measurement_id == measurement.id && locale == mt[i].locale){
                  measurementValLeft.label = mt[i].description;
                } 
              }
            }
            lhsVals.push(measurementValLeft);
          }
        }
      }
    }
  }

  return lhsVals;
}

const restoreRhsComparisonState = (currentNode,lhsValues,comparisonOperators, limitBoundaries,props) => {
  if(currentNode){
    let selectedMeasurement = lhsValues.find(element => element.value == currentNode.lhs);
    if(selectedMeasurement){
      if (selectedMeasurement.type == "MultiAnswerQuestionStep" || selectedMeasurement.type == "QuestionStep") {
        currentNode.operators = comparisonOperators.filter((theOperator) => theOperator.value === "equal" || theOperator.value == "notEqual");
        let theStep = props.stepsInfo.find(theStep => theStep.id == selectedMeasurement.step_id);
        if (theStep.choices && theStep.choices.length > 0) {
          let translations = interviewTranslations(props.translations,props.transIds,props.localeCode);
          currentNode.limits = extraTranslations(translations,theStep.choices);
        }
      }
      else{
        currentNode.operators = comparisonOperators;
        currentNode.limits = limitBoundaries;
      }
    }
  }
}

const RuleStatement = (props) => {
    const [t] = useTranslation();
    const comparisonOperators = [
      { value: "equal", label: t("views.interview.rules_editor.equal") },
      { value: "notEqual", label: t("views.interview.rules_editor.not_equal") },
      { value: "greaterThan", label: t("views.interview.rules_editor.greater_than")  },
      { value: "lessThan", label: t("views.interview.rules_editor.less_than") },
      { value: "greaterThanInclusive", label: t("views.interview.rules_editor.greater_than_inclusive")  },
      { value: "lessThanInclusive", label: t("views.interview.rules_editor.less_than_inclusive") }
    ];

    const limitBoundaries = [
      { value: "lowerLimit_marginal", label: t("views.interview.rules_editor.lower_limit_marginal")},
      { value: "upperLimit_marginal", label: t("views.interview.rules_editor.upper_limit_marginal")},
      { value: "lowerLimit_significant", label: t("views.interview.rules_editor.lower_limit_significant")},
      { value: "upperLimit_significant", label: t("views.interview.rules_editor.upper_limit_significant")}
    ];

    let {rules, updateRules, steps} = useContext(GlobalRulesContext);
    const [lhsValues, setLhsValues] = useState(getLhsValues(props.stepsInfo,interviewTranslations(props.translations,props.transIds,props.localeCode),props.measurements,props.localeCode));
    const [rhsValues, setRhsValues] = useState(limitBoundaries);
    const [operators, setOperators] = useState(comparisonOperators);
    let currentNode = props.nodeInfo;
    let stepsInfo = props.stepsInfo;

    restoreRhsComparisonState(currentNode,lhsValues,comparisonOperators,limitBoundaries,props);

    const onDeleteStatement = (event) => {
      let parent = currentNode.parent;
      const index = parent.children.findIndex(node => node.id === currentNode.id);
      if (index >= 0) {
        parent.children.splice(index, 1);
      }
      updateRules(rules, parent.id);
    };
    
    useEffect(() => {
    });
		
		const onMeasurementSelect = (measurement) => {
      if (currentNode) {
        currentNode.lhs = measurement.value;
        updateRules(rules, currentNode.id);
        let selectedMeasurement = lhsValues.find(element => element.value == measurement.value);
        if (selectedMeasurement.type == "SensorStep") {
          setRhsValues(limitBoundaries);
          setOperators(comparisonOperators);
        }
        else {
          let theStep = props.stepsInfo.find(theStep => theStep.id == selectedMeasurement.step_id);
          if (theStep.choices && theStep.choices.length > 0) {
            let translations = interviewTranslations(props.translations,props.transIds,props.localeCode);
            setRhsValues(extraTranslations(translations,theStep.choices));
            // setRhsValues(theStep.choices);
            setOperators(comparisonOperators.filter((theOperator) => theOperator.value === "equal" ||
            theOperator.value == "notEqual"));
          }  
        }
      }
    }

		
		const onComparisonSelect = (operator) => {
      if (currentNode) {
        currentNode.operator = operator.value;
        updateRules(rules, currentNode.id);
      }
		}
		
		const onLimitSelect = (limitValue) => {
      if (currentNode) {
        currentNode.rhs = limitValue.value;
        updateRules(rules, currentNode.id);
      }
    }
    
    return (
        <div className="single-line-container">
            <div className="dropdown-spacing">
              <Dropdown onChange={onMeasurementSelect} 
                        options={lhsValues}
                        value= {currentNode.lhs}
                        placeholder={t('views.interview.rules_editor.measurement')} />
            </div>
            <div className="dropdown-spacing">
              <Dropdown onChange={onComparisonSelect} 
                        options={currentNode.operators ? currentNode.operators : operators}
                        value={currentNode.operator}
                        placeholder={t('views.interview.rules_editor.compare')} />
            </div>  
            <div className="dropdown-spacing">
              <Dropdown onChange={onLimitSelect} 
                        options={currentNode.limits ? currentNode.limits : rhsValues}
                        value = {currentNode.rhs}
                        placeholder="Limits" />
            </div> 
            <div className= "action-button">
                <button className="btn btn-danger"
                        onClick={ onDeleteStatement }>
                  <i className="fa fa-trash"></i>
                </button>
            </div>
        </div>
    );
}

export default RuleStatement;